import { useEffect } from 'react';

import { version } from '../../package.json';

export const useVersionLogger = (): void => {
  useEffect(() => {
    console.log('Current app version:', version);
  }, []);
};
